module.exports = __webpack_public_path__ + "img/claas.2c2d84e6.jpg";